//libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'
import RichText from '/react4xp/components/RichText'
import SectionDivider from '/react4xp/components/SectionDivider'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface InfoBoxProps {
    disableDivider?: boolean
    title?: string
    text?: string
    cta?: {
        text: string
        href: string
        external?: boolean
    }
}

export default function InfoBox({
    disableDivider = false,
    title,
    text,
    cta
}: InfoBoxProps) {
    return (
        <>

            {!disableDivider && (
                <SectionDivider
                    marginBottom='big'
                />
            )}

            <Section className='infos-box'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-10 offset-md-1 col-xl-6 offset-xl-3'>
                            <div className='info-box__box'>

                                {isNonWhitespaceString(title) && (
                                    <h2 className='h1-hero-small'>
                                        {title}
                                    </h2>
                                )}

                                {isNonWhitespaceString(text) && (
                                    <RichText
                                        className='text-big'
                                        content={text}
                                    />
                                )}

                                {isNonWhitespaceString(cta?.text) && (
                                    <Button
                                        href={cta.href}
                                        noUnderline
                                        target={cta.external}
                                    >
                                        {cta.text}
                                    </Button>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </Section>

        </>
    )
}